import { render, staticRenderFns } from "./TrackDetailCovers.vue?vue&type=template&id=60cd02fa&"
import script from "./TrackDetailCovers.vue?vue&type=script&lang=js&"
export * from "./TrackDetailCovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports